import { TaskEditor } from '#/shared/ui/task-editor'

import { CompactTaskForm } from './compact-task-form'
import type { PanelState } from './panel-state'

export function TaskTab({
  task,
  compact,
  shipmentId,
}: {
  task: PanelState['task']
  compact?: boolean
  shipmentId?: string
}) {
  if (compact) return <CompactTaskForm task={task} shipmentId={shipmentId} />
  return (
    <TaskEditor
      open={task.open}
      value={task.value}
      onChange={task.onChange}
      onCreate={task.onCreate}
      onCancel={task.onCancel}
      onSave={task.onSave}
      isSubmitting={task.isSaving}
      userOptions={task.userOptions}
      usersLoading={task.usersLoading}
      userSearch={task.userSearch}
      onUserSearchChange={task.onUserSearchChange}
    />
  )
}
